import styled from 'styled-components';
import { layout } from '../../../../package.json';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  border: 1px solid var(--primary);
  padding: 1rem 2%;
  border-radius: 8px;
`;

export const ContainerPayments = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  > div + div {
    margin-left: 1rem;
  }

  @media (max-width: ${layout.tablet}) {
    flex-direction: column;
    > div + div {
    margin-left: 0rem;
    }
  }
`;


export const ContainerPaymentRight = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: 16rem;

  @media (max-width: ${layout.tablet}){
    flex-direction: row;
    max-width: 100%;
    > div + div {
      margin-left: 1rem;
    }
  }
  @media (max-width: ${layout.mobile}){
    flex-direction: column;
    > div + div {
      margin-left: 0rem;
    }
  }
`;

export const ContainerPaymentData = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;

  margin-top: 15px;

  width:  100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid var(--primary);
`;

export const ContainerDataRequest = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;

  width: 100%;

  padding: 5px;
  border-radius: 8px;


`;

export const ContainerDataRequestItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  width: 100%;
  padding: 0.5rem 2%;

  span {
    width: 100%;
    font-weight: 500;
  }

  span + span {
    margin-left: 0.5rem;
  }
`;

export const ContainerDefaultPayCard = styled.div`
  width: 100%;
  padding: 10px;
  border-radius: 8px;

  border: 1px solid var(--primary);
  background-color: #672d903b;
`;

export const CardNumber = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;

  margin-right: 10px;
  span {
    margin-left: 10px;
  }
`;

export const CardName = styled.div`
  margin-right: 10px;
`;

export const CardContainerSplit = styled.div`
  width: 100%;
`;
export const CardSplit = styled.div`
  width: 100%;
`;

export const ContainerPaymentLeft = styled.div`
width: 100%;
flex:1;
`

